import { ofType } from "redux-observable";
import { filter, map, retry, switchMap, take } from "rxjs/operators";
import { selectIsEventRunning } from "../../selectors/selectEventInfo";
import { selectOwnPlayerId } from "../../selectors/selectPlayerInfo";
import { selectPurchasePointsEventDetails } from "../../selectors/selectPurchasePointsEventInfo";
import { CommandCode, } from "../../utils/network/generated/protoTypes";
import { TypeActionEventInfo } from "../info/event/actionEventInfo";
import { actionPurchasePointsReceived } from "./actionPurchasePointsEventInfo";
export var epicPurchasePointsEventInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionEventInfo.Received), take(1), filter(function (action) {
        var state = state$.value;
        var purchasePointEvent = selectPurchasePointsEventDetails(state);
        var isPurchasePointsEventRunning = false;
        if (purchasePointEvent && purchasePointEvent[0]) {
            isPurchasePointsEventRunning = selectIsEventRunning(purchasePointEvent[0]);
        }
        return isPurchasePointsEventRunning;
    }), switchMap(function () {
        var playerId = selectOwnPlayerId(state$.value);
        return deps
            .netSend({
            id: CommandCode.PurchasePointInfo,
            props: {
                playerId: playerId,
            },
        })
            .pipe(map(actionPurchasePointsReceived), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/epicPurchasePointsEventInfo.ts
// module id = 2105
// module chunks = 3